<template>
  <qx-card title="车辆状态" padding="0" style="padding: 0;margin: 0;">
    <section slot="titleLeft" style="margin-left: 20px; cursor: pointer;">
      <span v-for="(item,index) in totalData" :key="index" @click="vehicleStateChange(item)">
        <span v-if="item.vehicleStateJt808===0" :style="`border-bottom:${item.vehicleStateCount>0?'1px solid #0088FF':''}`" class="statusItem">全部（{{item.vehicleStateCount}}）</span>
        <span  v-if="item.vehicleStateJt808===1" :style="`border-bottom:${item.vehicleStateCount>0?'1px solid #0088FF':''}`" class="statusItem">行驶（{{item.vehicleStateCount}}）</span>
        <span  v-if="item.vehicleStateJt808===2" :style="`border-bottom:${item.vehicleStateCount>0?'1px solid #0088FF':''}`" class="statusItem">静止（{{item.vehicleStateCount}}）</span>
        <span  v-if="item.vehicleStateJt808===3" :style="`border-bottom:${item.vehicleStateCount>0?'1px solid #0088FF':''}`" class="statusItem">离线（{{item.vehicleStateCount}}）</span>
      </span>
    </section>
      <section slot="titleRight">
        <qx-permpisions permpisions="">
          <el-button type="primary" @click="() => handleShowContent()" style="margin-left: 20px">
            {{showTable ?'收起':'展开'}}
          </el-button>
        </qx-permpisions>
      </section>
    <section class="tablePage" v-if="showTable" >
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            size="mini"
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
                :key="key"
                :prop="item.prop"
                :label="item.label"
                :sortable="item.sortable"
                :filters="item.filters"
                :filter-method="item.filterHandler"
                :min-width="item.minW"
                :width="item.w"
                :fixed="item.fixed"
            >
              <section slot-scope="scope">
                <section
                    v-if="scope.column.property === 'plateNumber'"
                    @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                    v-else-if="scope.column.property === 'vehicleStateJt808Name'"
                    style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;cursor: pointer"
                >
                  <el-popover placement="top" width="120" trigger="hover">
                    <div>
                      <span v-if=" scope.row.vehicleStateJt808!==2">{{ scope.row[scope.column.property] }}{{ scope.row.vehicleStateVulaeJt808Str}}</span>
                      <span v-else> {{ scope.row[scope.column.property] }}</span>
                    </div>
                    <div slot="reference">
                      <span v-if="scope.row.vehicleStateJt808!==2">{{ scope.row[scope.column.property] }} {{ scope.row.vehicleStateVulaeJt808Str}}</span>
                      <span v-else> {{ scope.row[scope.column.property] }}</span>
                    </div>
                  </el-popover>
                </section>
                <section
                    v-else-if="scope.column.property === 'vehicleLocationJt808'"
                    @click="toShowPoint(scope.row)"
                    style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                    class="primary cur"
                >
                  <el-popover placement="top-start" width="120" trigger="hover">
                    <div>
                      <span>{{ scope.row[scope.column.property] }}</span>
                    </div>
                    <span slot="reference">{{ scope.row[scope.column.property] }}</span>
                  </el-popover>

                </section>
                <section
                    v-else-if="scope.column.property === 'driverInformation'"

                >
                  <span class="primary cur" v-if="scope.row.driverUserId"  @click="toDriverDetail(scope.row, '')">
                    {{ scope.row[scope.column.property] }}
                  </span>
                  <span v-else></span>
                </section>
                <section v-else>
                  <span>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->

          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              fixed="right"
              width="100"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isCenter="true"
                  :isShowDropdown="true"
                  :btnList="[
                 {
                    permpisions: '',
                    showCondition: true,
                    name: '车辆轨迹',
                    event: () => toTrack(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import {queryVehicleMonitorInfo, queryVehicleStateStatistics} from 'api/index';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
  },
  data () {
    return {
      showTable: false,
      totalData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'vehicleStateJt808Name', label: '车辆状态', w: 150},
          { prop: 'vehicleLocationJt808', label: '实时位置', w: 200 },
          { prop: 'driverInformation', label: '主驾信息' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryVehicleMonitorInfo,
    handleShowContent () {
      this.showTable = !this.showTable;
    },
    toCarDetail (item) {
      const type = 'detail';
      this.jump({
        label: `查看车辆-${item.plateNumber}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&type=${type}`,
        full: true,
      });
    },
    toDriverDetail (item, type) {
      this.jump({
        label: '查看司机档案',
        url: `/manage/archives/driver/archives/detail?id=${item.driverUserId}&type=${type}`,
        full: true,
      });
    },
    toTrack (item) {
      let plateNumber = encodeURI(item.plateNumber);
      this.jump({
        label: `轨迹查询-${item.plateNumber}`,
        url: `/manage/operate/track/track?plateNumber=${plateNumber}`,
        full: true,
      });
    },
    toShowPoint (item) { // 定位到车辆位置
      item.lng = item.longitude;
      item.lat = item.latitude;
      this.$emit('locate', item);
    },
    async vehicleStateChange (item) {
      this.searchBoxData.vehicleStateJt808 = item.vehicleStateJt808;
      this.tableData.page = 1;
      this.getData();
      if (!this.showTable) {
        this.showTable = !this.showTable;
      }
    },
    async getVehicleData () {
      const res = await queryVehicleStateStatistics();
      res.sort((a, b) => a.vehicleStateJt808 - b.vehicleStateJt808);
      this.totalData = res;
    },
  },
  async created () {
    await this.getVehicleData();
  },
};
</script>

<style scoped lang="scss">
.statusItem{
  margin-left: 10px;
}
</style>
